import { render, staticRenderFns } from "./applica.vue?vue&type=template&id=b24faf94&scoped=true"
import script from "./applica.vue?vue&type=script&lang=js"
export * from "./applica.vue?vue&type=script&lang=js"
import style0 from "./applica.vue?vue&type=style&index=0&id=b24faf94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24faf94",
  null
  
)

export default component.exports